import React from 'react';
import {getLastCompletedStepLabel} from '../utils/getLastCompletedStepLabel';

export function LastCompletedStepColumnFormatter(cellContent) {
  return (
    <div className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap">
      {getLastCompletedStepLabel(cellContent)}
    </div>
  );
}
